import { Container, Form, Rating, TextArea } from '@mairistem/composants';
import { Panel, type PanelClass } from '@mairistem/finances-utils';
import React from 'react';

interface ImpactCollectiviteComponentProps {
	data: {
		impactCollectivite?: number;
		impactCollectiviteTexte?: string;
	};
	handlePin: () => void;
	onChange?: (updatedData: { [key: string]: any }) => void;
	panel: PanelClass;
}

const ImpactCollectiviteComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: ImpactCollectiviteComponentProps) => {
	const handleChange = (_e, { name, value }) => onChange?.({ [name]: value });

	const handleRate = (_e, { name, rating }) => onChange?.({ [name]: rating });

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Container textAlign="center">
				<Rating
					key="impactCollectivite"
					name="impactCollectivite"
					rating={data?.impactCollectivite ?? 0}
					onRate={handleRate}
					maxRating={5}
					data-testid="impactCollectiviteProjet"
					size="massive"
					icon="star"
					clearable
				/>
			</Container>
			<Form>
				<Form.Field
					key="impactCollectiviteTexte"
					name="impactCollectiviteTexte"
					value={data?.impactCollectiviteTexte ?? ''}
					fluid
					// @ts-expect-error
					control={TextArea}
					onChange={handleChange}
					data-testid="impactCollectiviteTexteProjet"
					rows={2}
				/>
			</Form>
		</Panel>
	);
};

export default ImpactCollectiviteComponent;
